
function getPrice(productIds, options)
{
  const defaultOptions = {
    asArray: false,
    asJson: false,
    storeId: null,
    userId: null,
  };
  options = Object.assign({}, defaultOptions, options)

  const csrfParam = document.querySelector('meta[name="csrf-param"]').getAttribute('content');
  const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  const data = { productIds, ...options }
  data[csrfParam] = csrfToken;

  return getPriceRequest(data)
}

function addProductToCart(id, quantity) {
  const productId = getProductGuid(id);
  if (productId) {
    document.dispatchEvent(new CustomEvent('add-basket-item',
      {detail: { productId, quantity }}
    ));
  }
}

function getProductGuid(productId) {
  const request = new XMLHttpRequest();
  request.open('GET', `/profile/api/get-product-guid/${productId}`, false);
  request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  request.send();

  const response = JSON.parse(request.responseText);

  return response.guid;
}

function getPriceRequest(data) {
  const request = new XMLHttpRequest();
  request.open('POST', '/profile/api/get-client-prices', false);
  request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  const formData = Object.keys(data).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
  }).join('&')
  request.send(formData);

  const responseText = request.responseText;
  if (request.status >= 200 && request.status < 400) {
    let result = null;
    const response = JSON.parse(responseText);

    if (data.asArray) {
      result = Object.entries(response).map((pair) => {
        return {
          productId: parseInt(pair[0]),
          price: parseFloat(pair[1].price),
          oldPrice: pair[1].oldPrice ? parseFloat(pair[1].oldPrice) : '',
        }
      });
    } else {
      result = Object.assign({}, response);
    }

    return data.asJson ? JSON.stringify(result) : result;

  } else {
    console.log(responseText);
    const result = data.asArray ? [] : {};
    return data.asJson ? JSON.stringify(result) : result;
  }
}